export default __webpack_public_path__ + "static/media/grandmaAndLady5.35037588.jpg";